import { Badge, Box, HStack, Link, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiSend } from "react-icons/fi";
import { EFormType, PublicationDto } from "../../autogen/bff-api";
import { buildDoffinNoticeUrl } from "./doffinNoticeUrl";
import { useDisplayDate } from "../../common/formatting/useDisplayDate";
import { SectionCard } from "../sourcing-events/portal/view-single/SectionCard";

export const PublicationsSection = ({ publications }: { publications: PublicationDto[] }) => {
  const { t } = useTranslation();
  const displayDate = useDisplayDate();

  if (publications.length === 0) return null;

  return (
    <SectionCard icon={FiSend} title={t("Publications")} count={publications.length}>
      <Stack spacing="2">
        {publications.map((p) => {
          const isChangeNotice = p.noticeVersion !== "01";
          const label = p.eFormType === EFormType.Can29
            ? t("Result notice")
            : p.eFormType === EFormType.ContractModification38
              ? t("Contract modification notice")
              : isChangeNotice
              ? t("Change notice")
              : t(p.eFormType);
          return (
            <HStack
              key={p.id}
              borderWidth="1px"
              borderColor="smBorder"
              rounded="md"
              px="4"
              py="3"
              justify="space-between"
              spacing="3"
            >
              <Box minW="0">
                <Text color="smText" fontSize="sm" fontWeight="medium">
                  {t(p.channel)} · {label}
                </Text>
                <Text color="smMuted" fontSize="xs">
                  {p.publishedAt ? displayDate(p.publishedAt) : t("Not published")}
                  {p.externalId ? ` · ${p.externalId}` : ""}
                  {` · ${t("Version")} ${p.noticeVersion}`}
                </Text>
              </Box>
              <HStack spacing="3" flexShrink={0}>
                {p.externalId && (
                  <Link href={buildDoffinNoticeUrl(p.externalId)} isExternal color="smPrimary" fontSize="sm">
                    {t("See on Doffin")}
                  </Link>
                )}
                <Badge colorScheme={isChangeNotice ? "purple" : "gray"} textTransform="none">
                  {t(p.status)}
                </Badge>
              </HStack>
            </HStack>
          );
        })}
      </Stack>
    </SectionCard>
  );
};
